





































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HomePage extends Vue {
  // @ts-ignore class-methods-use-this
  get items() {
    return [
      {
        title: 'Domek całoroczny DyngusParty 01',
        description: '<p>Seria domków drewnianych <strong>DyngusParty</strong> to jedyny segment w naszym asortymencie który sprzedaje się równie dobrze w sezonie zimowym jak i letnim.<p><p>Ten wyjątkowy domek całoroczny będzie nie tylko pięknym i estetycznym mieszkaniem na długie lata lecz także będzie stanowił niesamowitą wręcz ozdobę dla ogrodu. Szkło hartowane z którego zostały wykonane szyby przednie zadowoli najbardziej wymagających klientów. Nasze aranżacje wnętrz sprawią iż poczujecie się Państwo jak w domu!</p><p>Zachęcamy do wypróbowania naszego domku w stolicy domków <strong>Medical Creative Construction</strong> w Białej Podlaskiej <strong>ul. Armii Krajowej 11, 44-100 Biała Śląska</strong> nie czekaj i już dziś umów się na wizytę!</p>',
      },
      {
        title: 'Domek całoroczny DyngusParty 02',
        description: '<p>Ten wyjątkowy domek całoroczny będzie nie tylko pięknym i estetycznym mieszkaniem na długie lata lecz także będzie stanowił niesamowitą wręcz ozdobę dla ogrodu. Szkło hartowane z którego zostały wykonane szyby przednie zadowoli najbardziej wymagających klientów. Nasze aranżacje wnętrz sprawią iż poczujecie się Państwo jak w domu!</p>',
      },
      {
        title: 'Domek całoroczny DyngusParty 03',
        description: '<p>Seria domków drewnianych <strong>DyngusParty</strong> to jedyny segment w naszym asortymencie który sprzedaje się równie dobrze w sezonie zimowym jak i letnim.<p><p>Ten wyjątkowy domek całoroczny będzie nie tylko pięknym i estetycznym mieszkaniem na długie lata lecz także będzie stanowił niesamowitą wręcz ozdobę dla ogrodu. Szkło hartowane z którego zostały wykonane szyby przednie zadowoli najbardziej wymagających klientów. Nasze aranżacje wnętrz sprawią iż poczujecie się Państwo jak w domu!</p><p>Zachęcamy do wypróbowania naszego domku w stolicy domków <strong>Medical Creative Construction</strong> w Białej Podlaskiej <strong>ul. Armii Krajowej 11, 44-100 Biała Śląska</strong> nie czekaj i już dziś umów się na wizytę!</p>',
      },
    ];
  }
}
